<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  @if (!loading) {
  
  <div class="row">
    <div class="col-6">
      <t4-container title="{{'Turbo.Order.InvoiceDetailsDialog.lblHeader' | translate : 'Invoice'}}" [isLoading]="isLoading">
        <div  style="height: 350px; overflow-y: scroll; overflow-x: hidden;">
          <div class="row">
            <div class="col-12">
              <h5>{{ 'Turbo.Order.InvoiceDetailsDialog.lblGeneral' | translate:'General' }}</h5>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblCustomerName' |translate : 'Customer Name' }}:</span><span class="propValue" matTooltip="">{{invoice?.CustomerName }}</span></div>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblCustomerNumber' |translate : 'Customer Number' }}:</span><span class="propValue" matTooltip="">{{invoice?.CustomerNumber }}</span></div>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblInvoiceAccount1' |translate : 'Invoice Account' }}:</span><span class="propValue" matTooltip="">{{invoice?.InvoiceAccount }}</span></div>
              @if (invoice?.SalesId) {
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblSalesId1' | translate : 'Sales Id' }}:</span><span class="propValue" matTooltip="">{{invoice?.SalesId }}</span></div>
              }
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div class="col-12">
              <h5>{{ 'Turbo.Order.InvoiceDetailsDialog.lblDocuments' | translate:'Documents' }}</h5>
              @for(document of invoiceDocuments; track document.Name) {
              <div class="t4Property"><a [href]="document.Uri" style="margin-right: auto;" target="_blank">{{ document.Name }}</a></div>
              }
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div class="col-12">
              <h5>{{ 'Turbo.Order.InvoiceDetailsDialog.lblDetails' | translate:'Details' }}</h5>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblGeneratedAt' |translate : 'Generated at' }}:</span><span class="propValue" matTooltip="">{{invoice?.GeneratedAt | date : 'yyyy-MM-dd HH:mm' }}</span></div>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblSentAt' |translate : 'Sent at' }}:</span><span class="propValue" matTooltip="">{{invoice?.SentAt | date : 'yyyy-MM-dd HH:mm' }}</span></div>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblCompletedAt' | translate : 'Completed at' }}:</span><span class="propValue" matTooltip="">{{invoice?.CompletedAt | date : 'yyyy-MM-dd HH:mm' }}</span></div>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblAmount' | translate : 'Amount' }}:</span><span class="propValue" matTooltip="">{{invoice?.InvoiceAmount | currency }}</span></div>
              <div class="t4Property"><span class="propLabel" style="margin-top: 5px">{{'Turbo.Order.InvoiceDetailsDialog.lblVAT' | translate : 'VAT' }}:</span><span class="propValue" matTooltip="">{{invoice?.VatAmount | currency }}</span></div>
            </div>
          </div>
        </div>
      </t4-container>
    </div>
    <div class="col-6">
      <t4-container title="{{'Turbo.Order.InvoiceDetailsDialog.lblCommentsHeader' | translate : 'Comments'}}" [isLoading]="isLoading">
        <div style="height: 350px; overflow: scroll;">
          @if(entityEvents && entityEvents.length && entityEvents.length > 0) {
          <div class="container">
            @for(event of entityEvents; track event.Id) {
            <div class="row note normal-comment">
              <div class="col-xs-10" style="overflow: hidden; text-overflow: ellipsis;">
                {{ 'Turbo.Order.InvoiceDetailsDialog.Created' | translate : 'Created' }} {{ event.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}<br />
                {{ event.UserId }}
              </div>
              <div class="col-xs-12" [innerHtml]="event.Notes"></div><br /><br />              
            </div>
            }
          </div>
          }
          @if(entityEvents && entityEvents.length && entityEvents.length == 0) {
          <div class="row note">
            <div class="col-xs-12">
              <p>{{ 'Turbo.Order.InvoiceDetailsDialog.NoComments' | translate : 'No comments' }}</p>
            </div>
          </div>
          }
        </div>
      </t4-container>
    </div>
  </div>

  <t4-container title="{{'Turbo.Order.InvoiceDetailsDialog.lblLines' | translate : 'Lines'}}" [isLoading]="isLoading">
    <t4-data-table #tblInvoiceLines [rawData]="invoiceLines" headline="" matSort [autoGenerateColumns]="false">
      <ng-container matColumnDef="CheckInvoiceLines">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; max-width: 80px;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; max-width: 80px;">
          <mat-checkbox [(ngModel)]="row.Credit" name="rdbCredit{{row.ProductId}}"></mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ProductName">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 200px;">{{'Turbo.Order.InvoiceDetailsDialog.lblProduct' | translate : 'Product'}}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 200px;">
          {{ row.ProductName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Count">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; justify-content: center; min-width: 100px;">{{'Turbo.Order.InvoiceDetailsDialog.lblDetailCount' | translate : 'Count'}}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; justify-content: center; min-width: 100px;">
          {{ row.Count }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; justify-content: center; min-width: 150px;">{{'Turbo.Order.InvoiceDetailsDialog.lblAmount' | translate : 'Amount'}}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; justify-content: center; min-width: 150px;">
          {{ row.Price | currency }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="DeleteInvoiceLines">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100px"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; max-width: 100px;">
          @if((row.Price >= 0 && row.Price > row.CreditedAmount) || (row.Price < 0 && row.Price < row.CreditedAmount)) {
          <button mat-flat-button (click)="deleteRow(row)"><mat-icon>delete</mat-icon></button>
          }
        </mat-cell>
      </ng-container>
    </t4-data-table>
    <button (click)="createCreditInvoice()" color="primary" mat-raised-button id="cmdCredit" style="margin: 15px;" type="button" [disabled]="!anyChecked()">{{ 'Turbo.Order.InvoiceDetailsDialog.cmdCredit' | translate : 'Credit' }}</button>
  </t4-container>
  }
  @if (loading) {
  <mat-progress-bar mode="indeterminate" style="margin-left: -15px; position: absolute; width: calc(100% + 30px); top: 0px;"></mat-progress-bar>
  }
</mat-dialog-content>

